import styled from '@emotion/styled';
import { Link, useHistory } from 'react-router-dom';
import { GetDateInCurrentTimeZone } from '../../components/utilities/dateUtilities';
import { Order } from '../types';
import { LegacyIcon, AttachmentIcon } from '../../components/icons';
import LegacyOrderDetailsSlideout from '../OrderDetails/LegacyOrders/Container';
import { useState } from 'react';
import Highlight from '../../components/Highlight';
import { Layout } from '../OrderDetails/LegacyOrders/LegacyStyles';

const OrderInfo = styled.div`
  border-top: 0.75px solid #ccc9c6;
  padding: 14px 8px;
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #33322f;
  cursor: pointer;
  align-items: center;
  :hover {
    background-color: #f5f5f5;
  }
  @media (min-width: 768px) {
    font-size: 14px;
    display: grid;
    grid-template-columns: 20% 15% 37% 25%;
    grid-column-gap: 1%;
    padding: 14px 0px;
  }
`;
const OrderDetails = styled.div`
  max-width: 190px;
  @media (min-width: 768px) {
    display: contents;
  }
`;
const DateStyles = styled.div`
  @media (max-width: 767px) {
    display: none;
  }
  @media (min-width: 768px) {
    display: block;
  }
`;
const StatusStyles = styled.div<{ color: string }>`
  /* width: 100px; */
  height: 24px;
  font-size: 10px;
  display: flex;
  color: ${props => props.color};
  /* justify-content: center; */
  font-weight: 600;
  /* border-radius: 3px; */
  align-items: center;
  @media (min-width: 768px) {
    /* width: 148px; */
    height: 32px;
    font-size: 14px;
  }
`;
const LegacyStatusStyles = styled.div`
  display: flex;
  align-items: center;
  @media (min-width: 768px) {
    width: 175px;
    height: 32px;
    font-size: 14px;
  }
  @media (max-width: 767px) {
    align-items: flex-end;
    flex-direction: column;
  }
`;

const LegacyOrderStyles = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 112px;
  margin-right: 24px;
`;
const SidebarStyles = styled.div`
  z-index: 90000;
  width: 0;
  overflow: hidden;
  height: 100vh;
  background-color: #fff;
  position: fixed;
  right: 0;
  top: 0;
  box-shadow: 0px 16px 32px #eae8e5;
  transition: all 0.2s ease;
`;
const Overlay = styled.div`
  background-color: rgba(233, 232, 232, 0.5);
  bottom: 0;
  height: 100%;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 10000;
`;
interface Props {
  order: Order;
  backgroundColor?: string;
  searchText: string;
}

const ClientOrderRow = (props: Props) => {
  const date = GetDateInCurrentTimeZone(props.order.orderDate).format('MM/DD/YYYY');
  const history = useHistory();

  const [openSlidout, setOpenSlideout] = useState({ open: false, id: 0 });

  const callOpenSlideout = () => {
    const openSlideoutObj = {
      open: !openSlidout.open,
      id: props.order.id,
    };
    setOpenSlideout(openSlideoutObj);
  };

  const onClickRow = async () => {
    if (!props.order.isLegacy) {
      document.title = `Title ${props.order.titleNumber}`;
      // history.push(`/order/${props.order.id}`);
    } else {
      if (!openSlidout.open) {
        setOpenSlideout({ open: true, id: props.order.id });
      }
    }
  };

  const OrderRow = () => {
    return (
      <Link to={`/order/${props.order.id}`} style={{ textDecoration: 'none' }}>
        <OrderInfo onClick={onClickRow}>
          <OrderDetails>
            <div>{Highlight(props.order.titleNumber, props.searchText)}</div>
            <DateStyles>{date}</DateStyles>
            <div>
              <div>
                {props.order.addresses.length === 1 ? (
                  <div>{Highlight(props.order.addresses[0], props.searchText)}</div>
                ) : (
                  <div>{Highlight(props.order.addresses[0], props.searchText)}</div>
                )}
              </div>
              <div style={{ color: 'grey', fontSize: 11 }}>
                {props.order.propertiesCount > 1 && `${props.order.propertiesCount - 1}`}
                {props.order.propertiesCount > 2
                  ? ` additional properties`
                  : props.order.propertiesCount > 1 && ` additional property`}{' '}
              </div>
            </div>
          </OrderDetails>
          <StatusStyles
            color={
              props.order.status === 'In Progress'
                ? '#76ADB8'
                : props.order.status === 'Partially Completed'
                ? '#2C6794'
                : props.order.status === 'Completed'
                ? '#79A666'
                : props.order.status === 'Cancelled'
                ? '#B0B0B0'
                : props.order.status === 'On Hold'
                ? '#B0B0B0'
                : '#EF7458'
            }
          >
            {props.order.status}
          </StatusStyles>
        </OrderInfo>
      </Link>
    );
  };

  const LegacyOrderRow = () => {
    return (
      <OrderInfo onClick={onClickRow}>
        {openSlidout.open && <Overlay onClick={() => setOpenSlideout({ open: false, id: 0 })} />}
        <OrderDetails>
          <div>{props.order.titleNumber}</div>
          <DateStyles>{date}</DateStyles>
          <div>
            <div>
              {props.order.addresses.length === 1
                ? `${props.order.addresses[0]}`
                : `${props.order.addresses[0]}`}
            </div>
            <div style={{ color: 'grey', fontSize: 11 }}>
              {props.order.propertiesCount > 1 && `${props.order.propertiesCount - 1}`}
              {props.order.propertiesCount > 2
                ? ` additional properties`
                : props.order.propertiesCount > 1 && ` additional property`}{' '}
            </div>
          </div>
        </OrderDetails>
        <LegacyStatusStyles>
          <LegacyOrderStyles>
            <LegacyIcon />
            <div>Archived Order</div>
          </LegacyOrderStyles>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <AttachmentIcon />
            {props.order.legacyDocumentsCount}
          </div>
        </LegacyStatusStyles>
        {
          <SidebarStyles
            style={openSlidout.open ? { width: 498, overflow: 'auto', transition: 'all .2s' } : { width: 0 }}
          >
            <LegacyOrderDetailsSlideout
              width={openSlidout.open ? 498 : 0}
              legacyOrderId={openSlidout.id}
              onHideClick={() => callOpenSlideout()}
            />
          </SidebarStyles>
        }
      </OrderInfo>
    );
  };

  return !props.order.isLegacy ? <OrderRow /> : <LegacyOrderRow />;
};
export default ClientOrderRow;
